<template>
  <div>
    <b-card
      no-body
      class="mb-2 console-toolbar-card"
    >
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Log dosyası</label>
            <b-form-select
              v-model="filter.file"
              :options="fileOptions"
              @change="fetchLogs"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Seviye</label>
            <b-form-select
              v-model="filter.level"
              :options="levelOptions"
              @change="fetchLogs"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Satır</label>
            <b-form-select
              v-model.number="filter.lines"
              :options="lineOptions"
              @change="fetchLogs"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Ara</label>
            <b-form-input
              v-model="filter.search"
              placeholder="symbol, bot id, error..."
              @input="onSearchInput"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-1 d-flex align-items-end"
          >
            <div class="console-actions">
              <b-button
                variant="outline-primary"
                :disabled="loading"
                @click="fetchLogs"
              >
                <b-spinner
                  v-if="loading"
                  small
                />
                <feather-icon
                  v-else
                  icon="RefreshCwIcon"
                />
                Yenile
              </b-button>
              <b-form-checkbox
                v-model="autoRefresh"
                switch
                class="ml-1"
              >
                Auto
              </b-form-checkbox>
              <b-form-checkbox
                v-model="stickToBottom"
                switch
                class="ml-1"
              >
                Alta sabitle
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-alert
      v-if="dataSave.message"
      :variant="dataSave.status ? 'success' : 'danger'"
      show
      dismissible
      class="mb-2"
      @dismissed="$store.commit('systemConsole/SET_DATA_SAVE', { status: null, message: null })"
    >
      {{ dataSave.message }}
    </b-alert>

    <b-card
      no-body
      class="console-card"
    >
      <b-card-body class="console-title-row">
        <div>
          <h4 class="mb-0">
            Proje Konsolu
          </h4>
          <div class="font-small-3 text-muted">
            {{ payload.path }} · Güncelleme: {{ formatDateTime(payload.updatedAt) }}
          </div>
        </div>
        <div class="ml-auto text-right">
          <b-badge :variant="payload.exists ? 'light-success' : 'light-secondary'">
            {{ payload.exists ? 'Hazır' : 'Dosya yok' }}
          </b-badge>
          <b-badge
            class="ml-50"
            variant="light-info"
          >
            {{ payload.totalReturned || 0 }} satır
          </b-badge>
        </div>
      </b-card-body>

      <div
        ref="consoleBody"
        class="console-body"
      >
        <div
          v-if="loading && !lines.length"
          class="console-empty"
        >
          <b-spinner small /> Yükleniyor...
        </div>
        <div
          v-else-if="!payload.exists"
          class="console-empty"
        >
          Log dosyası bulunamadı. Production modda dosya logları otomatik oluşur.
        </div>
        <div
          v-else-if="!lines.length"
          class="console-empty"
        >
          Filtreye uygun log satırı yok.
        </div>
        <template v-else>
          <div
            v-for="line in lines"
            :key="`${line.index}-${line.text}`"
            class="console-line"
            :class="levelClass(line.level)"
          >
            <span class="console-line-meta">{{ line.timestamp || '--' }}</span>
            <span class="console-line-level">{{ (line.level || 'log').toUpperCase() }}</span>
            <span class="console-line-text">{{ line.text }}</span>
          </div>
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCol,
  BFormCheckbox,
  BFormInput,
  BFormSelect,
  BRow,
  BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'SystemConsoleIndex',
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCol,
    BFormCheckbox,
    BFormInput,
    BFormSelect,
    BRow,
    BSpinner,
  },
  data() {
    return {
      filter: {
        file: 'combined',
        level: 'all',
        lines: 300,
        search: '',
      },
      fileOptions: [
        { value: 'combined', text: 'Combined' },
        { value: 'error', text: 'Error' },
      ],
      levelOptions: [
        { value: 'all', text: 'Hepsi' },
        { value: 'error', text: 'Error' },
        { value: 'warn', text: 'Warn' },
        { value: 'info', text: 'Info' },
        { value: 'http', text: 'HTTP' },
        { value: 'debug', text: 'Debug' },
      ],
      lineOptions: [
        { value: 100, text: '100' },
        { value: 300, text: '300' },
        { value: 500, text: '500' },
        { value: 1000, text: '1000' },
        { value: 2000, text: '2000' },
      ],
      autoRefresh: true,
      stickToBottom: true,
      timer: null,
      searchTimer: null,
    }
  },
  computed: {
    payload() { return this.$store.getters['systemConsole/payload'] || {} },
    lines() { return this.$store.getters['systemConsole/lines'] || [] },
    loading() { return this.$store.getters['systemConsole/loading'] },
    dataSave() { return this.$store.getters['systemConsole/dataSaveStatus'] || {} },
  },
  watch: {
    autoRefresh() {
      this.configureTimer()
    },
    lines() {
      this.scrollToBottom()
    },
  },
  mounted() {
    this.fetchLogs()
    this.configureTimer()
  },
  beforeDestroy() {
    this.clearTimer()
    if (this.searchTimer) clearTimeout(this.searchTimer)
  },
  methods: {
    fetchLogs() {
      return this.$store.dispatch('systemConsole/fetch', { ...this.filter })
        .then(() => this.scrollToBottom())
    },
    configureTimer() {
      this.clearTimer()
      if (!this.autoRefresh) return
      this.timer = setInterval(() => {
        this.fetchLogs()
      }, 5000)
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    onSearchInput() {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => this.fetchLogs(), 350)
    },
    scrollToBottom() {
      if (!this.stickToBottom) return
      this.$nextTick(() => {
        const el = this.$refs.consoleBody
        if (el) el.scrollTop = el.scrollHeight
      })
    },
    levelClass(level) {
      if (level === 'error') return 'is-error'
      if (level === 'warn') return 'is-warn'
      if (level === 'debug') return 'is-debug'
      return 'is-info'
    },
    formatDateTime(value) {
      if (!value) return '-'
      try {
        return new Date(value).toLocaleString('tr-TR')
      } catch (e) {
        return value
      }
    },
  },
}
</script>

<style scoped>
.console-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem;
  width: 100%;
}

.console-title-row {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebe9f1;
}

.console-body {
  min-height: 540px;
  max-height: calc(100vh - 310px);
  overflow: auto;
  background: #10141f;
  color: #d6deeb;
  font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.55;
  padding: 0.85rem;
}

.console-empty {
  color: #9aa5b8;
  padding: 1rem;
  text-align: center;
}

.console-line {
  display: grid;
  grid-template-columns: 150px 62px minmax(0, 1fr);
  column-gap: 0.65rem;
  padding: 1px 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.console-line-meta {
  color: #7f8aa3;
}

.console-line-level {
  font-weight: 700;
}

.console-line-text {
  color: #d6deeb;
}

.console-line.is-error .console-line-level {
  color: #ff5c7a;
}

.console-line.is-warn .console-line-level {
  color: #ffc857;
}

.console-line.is-debug .console-line-level {
  color: #8bd3ff;
}

.console-line.is-info .console-line-level {
  color: #57d68d;
}

@media (max-width: 767px) {
  .console-body {
    min-height: 420px;
    max-height: 70vh;
  }

  .console-line {
    grid-template-columns: 1fr;
    row-gap: 0.1rem;
    padding: 0.25rem 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  }
}
</style>
